module.exports = __webpack_public_path__ + "static/media/encerrada-junte-ganhe.3ad8ed68.png";